<template>
  <div class="page-main">
    <div class="flex w-100">
      <b-filter-left
        ref="refLeftFilter"
        :init_filter_data="init_filter_data"
        :search_data="search_data"
        @success="updateLeftFilter"
      />
      <div class="flex-1 w-0">
        <div class="flex flex-y-center flex-x-between m-b-10">
          <div class="flex flex-y-center">
            <el-button type="success" size="mini" icon="el-icon-plus" @click="itemDo()"
              >新增送货单
            </el-button>
            <el-dropdown class="m-l-10">
              <el-button type="default" size="mini">
                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item @click.native="batchPass">
                  <span class="c-green">审核</span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="batchReject">
                  <span class="c-blue">反审核</span>
                </el-dropdown-item> -->
                <el-dropdown-item @click.native="batchDelete">
                  <span class="c-red">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="resetLeftFilter">
              <span>发货日期:</span>
              <e-date-picker
                type="daterange"
                :value.sync="delivery_date"
                isShowFast
                @change="resetLeftFilter"
              />
            </el-form>
          </div>
        </div>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          :show-footer="!!tableData.length"
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          :height="this.$util.getViewHeight() - 36 - 148"
          :footer-method="footerMethod"
          :cell-class-name="cellClassName"
          @cell-dblclick="itemDbDo"
          @resizable-change="handleColumnResize"
          @keydown="tableKeydown"
          @current-change="tableCurrentChange"
        >
          <!-- slot_default -->
          <template #default_delivery_code="{ row }">
            <el-link type="primary" @click="itemDo(row.delivery_id)">
              {{ row.delivery_code }}
            </el-link>
          </template>
          <template #default_delivery_status="{ row }">
            <el-tag v-if="row.delivery_status" type="success" size="mini" plain> 已审核 </el-tag>
            <el-tag v-else type="danger" size="mini" plain> 待审核 </el-tag>
          </template>
          <template #default_delivery_date="{ row }">
            {{ row.delivery_date.slice(0, 10) }}
          </template>
          <template #default_saler_name="{ row }">
            <div>{{ row.saler_name }}</div>
            <div v-if="row.shen_qing_bu_men_name" class="c-gray">
              ({{ row.shen_qing_bu_men_name }})
            </div>
          </template>
          <template #default_song_huo_total="{ row }">
            <span class="c-orange">{{ row.song_huo_total }}</span>
          </template>
          <template #default_operate="{ row }">
            <el-dropdown>
              <el-button type="default" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- v-if="row.isChuangJian || row.isFuZe" -->
                <el-dropdown-item @click.native="itemDo(row.delivery_id)">
                  <span class="c-blue">编辑</span>
                </el-dropdown-item>
                <!-- <el-dropdown-item
                  v-if="row.isChuangJian || row.isFuZe"
                  @click.native="itemPass(row.delivery_id)"
                >
                  <span class="c-gray">审核</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isChuangJian || row.isFuZe"
                  @click.native="itemReject(row.delivery_id)"
                >
                  <span class="c-gray">反审核</span>
                </el-dropdown-item> -->
                <el-dropdown-item @click.native="itemPrint(row.delivery_id)">
                  <span class="c-gray">打印</span>
                </el-dropdown-item>
                <el-dropdown-item
                  v-if="row.isChuangJian || row.isFuZe"
                  @click.native="itemDelete({ ids: [row.delivery_id], codes: [row.delivery_code] })"
                >
                  <span class="c-red">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
    </div>

    <!-- 弹窗-新增送货单 -->
    <PopupDo
      v-if="isShowPopupDo"
      :show.sync="isShowPopupDo"
      :detailId="activeId"
      :isAdmin="isAdmin"
      @success="updatePage"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_delivery_page_list',
  components: {
    PopupDo: () => import('../common/popup-do')
  },
  data() {
    return {
      // loading
      loading: true,

      // filter
      delivery_date: [this.$util.getDate().monthStart, this.$util.getDate().monthEnd],
      sortData: {
        delivery_code: 'desc'
      },
      init_filter_data: {
        active_parent_key: '送货单号',
        active_search_type: '单据',
        hide_count_keys: [],
        api_url_parent: '/admin/gcvip/songHuo4/leftFatherFilter3',
        api_url_child: '/admin/gcvip/songHuo4/leftFilter3'
      },
      left_filter_data: {
        search_type: '单据',
        list: []
      },

      // table
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        goods_count_all: '',
        goods_price_all: '',
        goods_amount_all: '',
        song_huo_total_all: ''
      },

      // popup
      isShowPopupDo: false,
      activeBillId: null,
      activeId: null
    }
  },
  computed: {
    // 搜索参数
    search_data() {
      let result = {
        delivery_date: this.delivery_date || []
      }
      return result
    },
    // 是否是管理员
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    // 当前登录账号id
    accountId() {
      return this.$store.state.loginAccount.id
    },
    // 表格列
    tableColumn() {
      let result = [
        {
          fixed: 'left',
          type: 'checkbox',
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '送货单号',
          field: 'delivery_code',
          slots: { default: 'default_delivery_code' },
          width: 110
        },
        {
          title: '销售单号',
          field: 'bill_code'
        },
        {
          title: '审核状态',
          field: 'delivery_status',
          slots: { default: 'default_delivery_status' }
        },
        {
          title: '客户',
          field: 'customer_name'
        },
        {
          title: '发货日期',
          field: 'delivery_date',
          slots: { default: 'default_delivery_date' }
        },
        {
          title: '制单人',
          field: 'saler_name',
          slots: { default: 'default_saler_name' }
        },
        {
          title: '部门',
          field: 'bu_men_name'
        },
        {
          title: '品名',
          field: 'goods_name'
        },
        {
          title: '规格(mm)',
          field: 'goods_spec'
        },
        {
          title: '单位',
          field: 'goods_unit'
        },
        {
          title: '送货数量',
          field: 'song_huo_count'
        },
        {
          title: '单价(元)',
          field: 'goods_price'
        },
        {
          title: '送货金额(元)',
          field: 'song_huo_amount'
        },
        {
          title: '送货单金额(元)',
          field: 'song_huo_total',
          slots: { default: 'default_song_huo_total' },
          width: 100
        },
        {
          title: `备注`,
          field: 'goods_remark',
          width: 160
        },
        {
          title: `单据备注`,
          field: 'remark',
          width: 160
        },
        {
          title: '开单公司',
          field: 'saler_company_name',
          width: 200
        },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 更新页面
    updatePage() {
      this.$refs.refLeftFilter.updateFilterGroupData()
      this.searchListData()
    },
    // 重置左侧筛选
    resetLeftFilter() {
      if (!this.left_filter_data.list.length) {
        let result = {
          search_type: this.init_filter_data.active_search_type,
          list: []
        }
        this.updateLeftFilter(result)
      }
    },
    // 更新左侧筛选
    updateLeftFilter(val) {
      this.left_filter_data = this.$util.deepCopy(val)
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let params = {
        is_ming_xi: false,
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        delivery_date: this.search_data.delivery_date,
        sortData: this.$util.deepCopy(this.sortData)
      }
      if (this.left_filter_data.list.length) params.left_filter = this.left_filter_data.list

      this.$api({
        method: 'post',
        url: '/admin/gcvip/songHuo4/list',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            list.forEach((item) => {
              item.isChuangJian = this.isAdmin || item.saler_id === this.accountId
              item.isFuZe = this.isAdmin || item.fu_ze_ren_id === this.accountId
            })
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.goods_count_all = res.data.goods_count_all
            this.totalObj.goods_price_all = res.data.goods_price_all
            this.totalObj.goods_amount_all = res.data.goods_amount_all
            this.totalObj.song_huo_total_all = res.data.song_huo_total_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'song_huo_count') return this.totalObj.goods_count_all
          if (column.field === 'goods_price') return this.totalObj.goods_price_all
          if (column.field === 'song_huo_amount') return this.totalObj.goods_amount_all
          if (column.field === 'song_huo_total') return this.totalObj.song_huo_total_all
        })
      ]
    },
    // 行类名计算，实现按字段分组的斑马纹效果
    cellClassName(rowData) {
      let result = this.$tool.getTableCellClassName(this.tableData, rowData, 'delivery_code')
      return result
    },
    // 项-增改-送货单
    itemDo(id = null) {
      this.activeId = id
      this.isShowPopupDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.delivery_id)
    },
    // 项-打印
    itemPrint(id) {
      window.open(`/new/delivery/print?id=${id}`, '_blank')
    },
    // 项-审核
    itemPass() {
      this.$util.moduleLoading('审核')
    },
    // 项-反审核
    itemReject() {
      this.$util.moduleLoading('反审核')
    },
    // 批量-审核
    batchPass() {
      this.$util.moduleLoading('审核')
    },
    // 批量-反审核
    batchReject() {
      this.$util.moduleLoading('反审核')
    },
    // 批量-删除
    batchDelete() {
      this.$util.moduleLoading('删除')
      // let rows = this.getCheckboxRecords()
      // if (rows.length) {
      //   this.isShowPopupBatch = true
      //   let ids = rows.map((item) => item.delivery_id)
      //   let codes = rows.map((item) => item.delivery_code)

      //   let obj = {
      //     ids: [...new Set(ids)],
      //     codes: [...new Set(codes)]
      //   }
      //   this.itemDelete(obj)
      // } else {
      //   this.itemChoosePrompt()
      // }
    },

    // 项-删除
    itemDelete(obj) {
      this.$confirm(`您确定要删除编码为"${obj.codes.join(',')}"的送货单吗?`, '提示')
        .then(() => {
          this.deleteConfirm(obj.ids)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    deleteConfirm(ids) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/songHuo4/batch',
        params: {
          ids: ids.join(',')
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('操作成功')
            this.getListData()
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
